export default "__VITE_ASSET__CXlvZKiZ__"